module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedExtraBold.1e8805d.woff2";